import RoundVisual from "./Round";
import { Round } from "./Parsing";

type Props = {
    rounds: Round[],
    gauge: number[],
    onHover: (round: number) => void,
    hoverActive: boolean,
    userId: string,
    taskId: string
}

export default function Visual(props: Props) {
    return (
        <>
            <div className="visual">
                {props.rounds.map((round: Round, index: number) => {
                    return <RoundVisual
                        index={index}
                        key={`row-${index}`}
                        round={round}
                        gauge={props.gauge}
                        hoverActive={props.hoverActive}
                        onMouseEnter={(id) => props.onHover(id)}
                        userId={props.userId}
                        taskId={props.taskId}
                    />
                })}
            </div>
        </>
    );
}